import React from 'react';
import { Modal, Button, Space, Select, Typography } from 'antd';
import { SoundOutlined, PlayCircleOutlined, StopOutlined, SendOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SoundModal = ({
  visible,
  selectedSound,
  setSelectedSound,
  previewingSound,
  setPreviewingSound,
  broadcastingSound,
  onClose,
  handleBroadcastSound,
  announcementSounds,
  previewSound
}) => {

  const handleStopPreview = () => {
    if (previewingSound) {
      previewingSound.pause();
      previewingSound.currentTime = 0;
      setPreviewingSound(null);
    }
  };

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <SoundOutlined style={{ color: '#1890ff' }} />
          <span>Play Sound</span>
        </div>
      }
      open={visible}
      onCancel={() => {
        handleStopPreview();
        onClose();
      }}
      footer={[
        <Space style={{ marginTop: '16px' }}>
          <Button
            key="cancel"
            onClick={() => {
              handleStopPreview();
              onClose();
            }}
          >
            Cancel
          </Button>,
          <Button
            key="broadcast"
            type="primary"
            icon={<SendOutlined />}
            loading={broadcastingSound}
            onClick={handleBroadcastSound}
            disabled={!selectedSound}
          >
            Broadcast Sound
          </Button>
        </Space>
      ]}
      width={500}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div>
          <Text strong style={{ display: 'block', marginBottom: '8px', fontSize: '13px' }}>
            Select Sound
          </Text>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
            <Select
              style={{ flex: 1, minWidth: '200px' }}
              value={selectedSound}
              onChange={setSelectedSound}
              placeholder="Select a sound to play for all users"
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {announcementSounds.map((sound) => (
                <Select.Option key={sound.value} value={sound.value}>
                  {sound.label}
                </Select.Option>
              ))}
            </Select>

            {selectedSound && (
              <Button
                type="default"
                icon={previewingSound ? <StopOutlined /> : <PlayCircleOutlined />}
                onClick={() => {
                  if (previewingSound) {
                    handleStopPreview();
                  } else {
                    previewSound(selectedSound);
                  }
                }}
              >
                {previewingSound ? 'Stop Preview' : 'Preview'}
              </Button>
            )}
          </div>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#8c8c8c' }}>
            Select a sound to play for all participants. You can preview it before broadcasting.
          </div>
        </div>
      </Space>
    </Modal>
  );
};

export default SoundModal;
